import { __rest, __assign } from 'tslib';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import cuid from 'cuid';
import { forwardRef } from 'react';
import { Box } from '../Box/index.js';
import { FormField } from '../FormField/FormField.js';
import '../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import { useTheme } from '../hooks/useTheme.js';
import { TextInputEnds } from './TextInputEnds.js';

var TextInput = forwardRef(function (_a, ref) {
    var _b = _a.id, id = _b === void 0 ? cuid() : _b, value = _a.value, defaultValue = _a.defaultValue, prefix = _a.prefix, suffix = _a.suffix, iconLeft = _a.iconLeft, iconRight = _a.iconRight, size = _a.size, onChange = _a.onChange, _c = _a.disabled, disabled = _c === void 0 ? false : _c, invalid = _a.invalid, 
    // FormField props
    error = _a.error, label = _a.label, hint = _a.hint, subCopy = _a.subCopy, info = _a.info, props = __rest(_a, ["id", "value", "defaultValue", "prefix", "suffix", "iconLeft", "iconRight", "size", "onChange", "disabled", "invalid", "error", "label", "hint", "subCopy", "info"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var _d = handleStyleProps(__assign({ size: size, invalid: invalid }, props), {
        themeKey: "textInput",
        baseStyle: { boxSizing: "border-box" },
    }), css = _d.css, forwardProps = __rest(_d, ["css"]);
    var padding = css.padding, inputCss = __rest(css, ["padding"]);
    var formFieldProps = {
        error: error,
        label: label,
        hint: hint,
        subCopy: subCopy,
        info: info,
        size: size,
        fieldId: id,
    };
    var handleChangeEvent = function (event) {
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    return (jsx(FormField, __assign({}, formFieldProps, { children: jsxs(Box, __assign({ css: inputCss }, (disabled && { "data-disabled": true }), { children: [Boolean(prefix) && (jsx(TextInputEnds, __assign({ size: size }, { children: prefix }))), jsxs(Box, __assign({ css: {
                        padding: padding,
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                    } }, { children: [iconLeft, jsx(Box, __assign({ component: "input", id: id, ref: ref, value: value, defaultValue: defaultValue, onChange: handleChangeEvent, "aria-invalid": Boolean(invalid), disabled: disabled, sx: {
                                border: 0,
                                outline: "none",
                                fontSize: "inherit",
                                width: "100%",
                                margin: "auto",
                                background: "inherit",
                            } }, forwardProps)), iconRight] })), Boolean(suffix) && (jsx(TextInputEnds, __assign({ end: "suffix", size: size }, { children: suffix })))] })) })));
});
TextInput.displayName = "TextInput";

export { TextInput };
//# sourceMappingURL=TextInput.js.map
